import { OrderLog  } from "../../classes";

const OrderLogModule = {
  namespaced: true,
  state: {
  },
  actions: {
    getOrderLogs: async ({ commit }, payload) => {
      try {
        const data = await OrderLog.getOrderLogs(payload);
        return data;
      } catch (err) {
        throw err;
      }
    },
  },
  getters: {

  },
  mutations: {

  }
};
export default OrderLogModule;
